import { render, staticRenderFns } from "./refund-table.vue?vue&type=template&id=8a743fa0&scoped=true&"
import script from "./refund-table.vue?vue&type=script&lang=js&"
export * from "./refund-table.vue?vue&type=script&lang=js&"
import style0 from "./refund-table.vue?vue&type=style&index=0&id=8a743fa0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a743fa0",
  null
  
)

export default component.exports